<div class="empty-results-placeholder" [ngClass]="{ borderless: borderless !== false }">
  <app-icon color="tertiary" size="extra-large" hoverColor="tertiary">plagiarism</app-icon>

  <span>{{ emptyResultsTitle }}</span>

  <span>{{ emptyResultsText }}</span>
</div>
